import { render, staticRenderFns } from "./PaymentDetails.vue?vue&type=template&id=70df2694&scoped=true&"
import script from "./PaymentDetails.vue?vue&type=script&lang=ts&"
export * from "./PaymentDetails.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentDetails.vue?vue&type=style&index=0&id=70df2694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70df2694",
  null
  
)

export default component.exports